"use client";

import { c as _c } from "react-compiler-runtime";
import { motion } from "motion/react";
type GoldenRatioOverlayProps = {
  readonly isActive: boolean;
};
export default function GoldenRatioOverlay(t0) {
  const $ = _c(8);
  const {
    isActive
  } = t0;
  if (!isActive) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: [0.24, 0.4, 0.24]
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0.24
    };
    t3 = {
      duration: 2.8,
      ease: "linear",
      repeat: Infinity
    };
    t4 = <div className="border-primary/20 absolute inset-[10%] rounded-[1.4rem] border" />;
    t5 = <div className="bg-primary/20 absolute inset-y-[12%] left-1/2 w-px -translate-x-1/2" />;
    t6 = <div className="bg-primary/16 absolute inset-x-[14%] top-[38.2%] h-px" />;
    t7 = <div className="bg-primary/14 absolute inset-y-[18%] left-[38.2%] w-px" />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <motion.div aria-hidden={true} animate={t1} className="pointer-events-none absolute inset-0" initial={t2} transition={t3}>{t4}{t5}{t6}{t7}<svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100"><path className="text-primary/25" d="M18 18 L82 18 L50 82 Z" fill="none" stroke="currentColor" strokeWidth="0.7" /><circle className="text-primary/16" cx="50" cy="42" fill="none" r="18" stroke="currentColor" strokeWidth="0.55" /></svg></motion.div>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
}